// extracted by mini-css-extract-plugin
export default {"notfoundpage":"NotFound_notfoundpage__ZBZ0E","nf_img":"NotFound_nf_img__MTj48","h1":"NotFound_h1__8yRU2","p":"NotFound_p__q446j"};